module.exports = __webpack_public_path__ + "img/temperature-humidity-chamber.57521bec.jpg";